import policy from '../assets/app_private.txt';
import {useEffect, useState} from "react";

const AppPrivatePage = () => {
    const [content, setContent] = useState('');

    useEffect(() => {
        fetch(policy)
            .then((response) => response.text())
            .then((text) => setContent(text))
            .catch((error) => console.error('Error loading the text file:', error));
    }, []);

    return (
         <div style={{padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6'}}>
            <h1>보나스포츠 약관정보</h1>
            <pre style={{
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
                background: '#f4f4f4',
                padding: '15px',
                borderRadius: '8px'
            }}>
                {content}
              </pre>
        </div>
    );
}
export default AppPrivatePage;